import DriverPotentialPlanRequest from "../../../api/raily/driver/potential-plan/driver-potential-plan.request";
import DriverPotentialPlanParams from "./driver-potential-plan-params";

const create = (
  params: DriverPotentialPlanParams,
): DriverPotentialPlanRequest => {
  return {
    driverUuid: params.driverUuid,
  };
};

const driverPotentialPlanParamsFactory = {
  create,
};

export default driverPotentialPlanParamsFactory;
